import { render, staticRenderFns } from "./EmptyComment.vue?vue&type=template&id=7048d17c&scoped=true&"
import script from "./EmptyComment.vue?vue&type=script&lang=js&"
export * from "./EmptyComment.vue?vue&type=script&lang=js&"
import style0 from "./EmptyComment.vue?vue&type=style&index=0&id=7048d17c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7048d17c",
  null
  
)

export default component.exports